import { CalendarColors } from 'app/App.constants';

// Types
import CalendarLegends from 'app/types/CalendarLegends';

export const parseQueryByName = (search, name) => {
  if ( !search ) return '';
  return new URLSearchParams(search).get(name);
}

const colorCache = {};
const usedColors = new Set();

export const getVisitColor = (visitType) => {
  if ( !visitType || visitType === CalendarLegends.Unassigned ) return '#ff0000';

  if (colorCache[visitType]) return colorCache[visitType];

  const baseIndex = _floorMod(_hashString(visitType), CalendarColors.length);

  let assignedColor;
  for (let i = 0; i < CalendarColors.length; i++) {
    const index = (baseIndex + i) % CalendarColors.length;
    const candidate = CalendarColors[index];
    if (!usedColors.has(candidate)) {
      assignedColor = candidate;
      break;
    }
  }

  if (!assignedColor) {
    assignedColor = CalendarColors[baseIndex];
  }

  colorCache[visitType] = assignedColor;
  usedColors.add(assignedColor);

  return assignedColor;
};

const _floorMod = (x, y) => {
  const r = Math.floor(x / y);
  return x - r * y;
};

const _hashString = value => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = ((hash << 5) - hash) + value.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};
